<section class="profile-page flex flex-col font-display w-full max-w-6xl mx-auto p-4 sm:p-6">
  <div class="page-header">
    <div class="min-w-0 flex-1">
      <p class="text-xs font-medium text-slate-500 mb-1">Profil pengguna</p>
      <h1 class="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
        {{ getFullName() }}
      </h1>
      <p class="text-sm text-slate-500 mt-1">
        Detail informasi pengguna dalam sistem.
      </p>
    </div>
    <button type="button" class="btn-secondary" (click)="goBack()">
      <i class="fa-solid fa-arrow-left text-xs"></i>
      Kembali
    </button>
  </div>

  <div class="profile-hero" *ngIf="profileData">
    <div class="profile-hero__main">
      <img
        [src]="imageUrl || 'profile.png'"
        alt="Foto profil"
        class="profile-hero__avatar"
      />
      <div class="min-w-0">
        <p class="profile-hero__name">{{ getFullName() }}</p>
        <p class="profile-hero__email">{{ profileData.email ?? "-" }}</p>
      </div>
    </div>
    <div class="profile-hero__meta">
      <span class="employee-badge"
        >ID karyawan {{ profileData.employeeId ?? "-" }}</span
      >
      <span class="role-badge">{{ getRolesLabel() }}</span>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-6" *ngIf="profileData">
    <div class="section-card">
      <div class="section-card__header">
        <span class="section-card__title">Data pribadi</span>
      </div>
      <div class="section-card__body">
        <div class="info-grid">
          <div class="info-field">
            <span class="info-field__label">Nama depan</span>
            <span class="info-field__value">{{
              profileData.firstName ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Nama belakang</span>
            <span class="info-field__value">{{
              profileData.lastName ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Jenis kelamin</span>
            <span class="info-field__value">{{
              profileData.gender ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Email</span>
            <span class="info-field__value">{{ profileData.email ?? "-" }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Tanggal lahir</span>
            <span class="info-field__value">{{
              formatDate(profileData.birthDate)
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Tempat lahir</span>
            <span class="info-field__value">{{
              profileData.placeOfBirth ?? "-"
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card__header">
        <span class="section-card__title">Data kepegawaian</span>
      </div>
      <div class="section-card__body">
        <div class="info-grid">
          <div class="info-field">
            <span class="info-field__label">ID karyawan</span>
            <span class="info-field__value">{{
              profileData.employeeId ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Posisi</span>
            <span class="info-field__value">{{
              profileData.position ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Status kepegawaian</span>
            <span class="info-field__value">{{
              profileData.statusEmployment ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Team</span>
            <span class="info-field__value">{{
              profileData.team?.name ?? "-"
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Tanggal bergabung</span>
            <span class="info-field__value">{{
              formatDate(profileData.joinDate)
            }}</span>
          </div>
          <div class="info-field">
            <span class="info-field__label">Tanggal berakhir</span>
            <span class="info-field__value">{{
              formatDate(profileData.endDate)
            }}</span>
          </div>
          <div class="info-field info-field--full">
            <span class="info-field__label">Role</span>
            <span class="info-field__value">{{ getRolesLabel() }}</span>
          </div>
          <div class="info-field info-field--full">
            <span class="info-field__label">Maks. cash advance</span>
            <span class="info-field__value">{{
              profileData.maximumAmount
                ? (profileData.maximumAmount
                  | currency : "IDR" : "symbol" : "1.0-0")
                : "-"
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card__header">
        <span class="section-card__title">Informasi rekening</span>
      </div>
      <div class="section-card__body">
        <div class="bank-grid">
          <div class="bank-item">
            <span class="bank-item__label">Bank</span>
            <span class="bank-item__value">{{
              profileData.bankName ?? "-"
            }}</span>
          </div>
          <div class="bank-item">
            <span class="bank-item__label">Atas nama</span>
            <span class="bank-item__value">{{
              profileData.bankAccountName ?? "-"
            }}</span>
          </div>
          <div class="bank-item">
            <span class="bank-item__label">No. Rekening</span>
            <span class="bank-item__value">{{
              profileData.bankAccountNumber ?? "-"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
